import * as React from 'react';
import { CmdTooltip } from '@commander-services/gui-components';
import { useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { IRide } from '../types';
import {
  activeRideIndexAtom,
  actualPlayPositionAtom,
  autoplayAtom,
  isRideActiveAtom,
  pauseAtom,
  playAtom,
  selectedRidesAtom,
  showDataLayerAtom,
} from '../RidePlayerState';

interface IDistanceWidgetProps {
  rides: IRide[];
  isLastRidePlayer?: boolean;
}

export default function DistanceWidget(props: IDistanceWidgetProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const actualPosition = useRecoilValue<number>(actualPlayPositionAtom);
  const showContent = useRecoilValue<boolean>(showDataLayerAtom);
  const play = useRecoilValue<boolean>(playAtom);
  const pause = useRecoilValue<boolean>(pauseAtom);
  const isRideActive = useRecoilValue<number | false>(isRideActiveAtom);
  const autoplay = useRecoilValue<boolean>(autoplayAtom);
  const activeRideIndex = useRecoilValue<number>(activeRideIndexAtom);
  const selectedRides = useRecoilValue<number[]>(selectedRidesAtom);
  const activeRideNumber = selectedRides[activeRideIndex];
  const rideIndex = activeRideNumber - 1;

  let distance = 0;
  // If ride is in multiplayer
  if ((showContent && isRideActive) || props.rides.length === 1) {
    if (
      props.rides[rideIndex] &&
      props.rides[rideIndex].positions[actualPosition] &&
      props.rides[rideIndex].positions[actualPosition].distanceCumulative
    ) {
      distance = Number(props.rides[rideIndex].positions[actualPosition].distanceCumulative);
    }
  } else {
    // If ride is on last ride player
    props.rides.forEach((ride: IRide, index) => {
      if (selectedRides.includes(ride.rideData.key)) {
        if (props.rides[index] && props.rides[index].rideData.distance) {
          distance += props.rides[index].rideData.distance;
        }
      }
    });
  }

  const shortenLongerValue = (value: number) => {
    if (value > 999) {
      return value.toFixed(0);
    }
    return value.toFixed(2);
  };

  const getDistanceTitle = (): string => {
    if ((play || pause || !autoplay) && !props.isLastRidePlayer && isRideActive) {
      return f({ id: 'ridePlayer.widget.distance.tooltip.activeRide' });
    }
    if (!play && !pause && autoplay && !props.isLastRidePlayer && isRideActive) {
      return f({ id: 'ridePlayer.widget.distance.tooltip.activeRide' });
    }
    if (props.rides.length === 1) {
      return f({ id: 'ridePlayer.widget.distance.tooltip.activeRide' });
    }
    if (props.isLastRidePlayer) {
      return f({ id: 'ridePlayer.widget.distance.tooltip' });
    }
    return f({ id: 'ridePlayer.widget.distance.tooltip.allRides' });
  };

  return (
    <div className="item">
      <div className="b-widget b-widget--1x1" style={{ position: 'initial', textAlign: 'center' }}>
        <CmdTooltip
          customCss={{ whiteSpace: 'nowrap', textAlign: 'center', top: '53px' }}
          content={<>{getDistanceTitle()}</>}
          width={props.rides.length > 1 && !isRideActive && !props.isLastRidePlayer ? 320 : 180}
        >
          <i className="e-widget-icon cmd-icon cmd-icon-arrival-distance" />
          <div className="e-widget-value">
            <strong>{shortenLongerValue(distance)}</strong>
            <small>km</small>
          </div>
        </CmdTooltip>
      </div>
    </div>
  );
}
